import axios from "axios";
export const HTTP = axios.create({
    baseURL:window.VUE_CONFIG_API,
})
// ECommerceAdmin fork: authenticate to PaymentAPI via X-API-Key on every request
// (GetSecureAdminUser). Set once at instance creation from window config so GET/PUT/POST
// all carry it, independent of login order.
if(window.VUE_CONFIG_API_KEY){
    HTTP.defaults.headers.common['X-API-Key']=window.VUE_CONFIG_API_KEY
}

// SER-331: when an admin call returns 401 (per-user token expired/invalid once enforcement is on),
// the session is no longer authorized. The fork keeps no persisted session, so a one-time reload
// returns to the login gate. Guard against loops and skip the login call itself.
let handling401 = false
HTTP.interceptors.response.use(
    response => response,
    error => {
        const status = error && error.response && error.response.status
        const url = (error && error.config && error.config.url) || ''
        if(status === 401 && !handling401 && url.indexOf('walletloginuser') === -1){
            handling401 = true
            try{ if(HTTP.defaults.headers.common){ delete HTTP.defaults.headers.common['adminuser'] } }catch(e){}
            window.location.reload()
        }
        return Promise.reject(error)
    }
)


export const HTTPImage = axios.create({
    baseURL:window.VUE_CONFIG_API_IMAGE,
})

export const ReportHTTP = axios.create({
    baseURL:window.VUE_CONFIG_ReportAPI,
})

export const HTTPTerminal = axios.create({
    baseURL:window.TERMINAL_URL,
})